
import React, { ReactNode } from 'react';
import styles from './_dynamic-button.module.scss';
import { IconButton } from '@mui/material';
import { Button } from '@progress/kendo-react-buttons';

export interface DynamicButtonProps {
  title: string
  useIconButton: boolean;
  buttonContent?: ReactNode;
  color: string;
  disabled?: boolean;
  fillMode?: 'solid' | 'outline';
  style?: React.CSSProperties;
  titleStyle?: React.CSSProperties;
  onClick: () => void;
}

export default function DynamicButton(props: DynamicButtonProps) {
  return (
    <>
      {props.useIconButton && <IconButton
        title={props.title}
        className={styles.denseButton}
        style={props.style}
        onClick={() => {
          props.onClick();
        }}
      >
        {props.buttonContent}
      </IconButton>}
      {!props.useIconButton && <Button
        fillMode={props.fillMode}
        style={props.style}
        color={props.color}
        
        disabled={props.disabled}
        onClick={() => {
          props.onClick();
        }}
      >
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
          {props.buttonContent}
          <span style={props.titleStyle}>{props.title}</span>
        </div>
      </Button>}

    </>
  );
}
